import React, { Component } from 'react'
import {Link} from 'react-router-dom';
import './Footer.scss';
import Logo from './logowhite.svg';
import Youtube from './socialicon/Youtube.svg';
import Instagram from './socialicon/instagram.svg';
import Twitter from './socialicon/Twitter.svg';
import Facebook from './socialicon/Facebook.svg';

export class Footer extends Component {
    render() {
        return (
            <div className="footer">
                <div className="footer-container">
                    <div className="inner_footer">
                        <div className="logo_container">
                        <Link to="/"><img alt="Logo" src={Logo}/></Link>
                        </div>
                        <div className="footer_third">
                            <h3>About</h3>
                            <a target="_blank" rel="noopener noreferrer" href="https://youtube.com/">
                                Contact Us
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/">
                                Become our Partner
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/">
                                Terms and Conditions   
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/">
                                Privacy Policy  
                            </a>
                        </div>
                        {/* <div className="footer_third">
                            <h3>Not yet</h3>
                            <a target="_blank" rel="noopener noreferrer" href="https://youtube.com/">
                                
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/">
                                
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/">
                                
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/">
                                
                            </a>
                        </div> */}
                        <div className="footer_third">
                            <h3>Social</h3>
                            <a target="_blank" rel="noopener noreferrer" href="https://youtube.com/">
                                <img src={Youtube} alt="Youtube"/> Youtube
                            </a>

                            <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/">
                                <img src={Instagram} alt="Instagram"/> Instagram
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/">
                                <img src={Twitter} alt="Twitter"/> Twitter
                            </a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/">
                                <img src={Facebook} alt="Facebook"/> Facebook
                            </a>
                        </div>
                    </div>
                </div>
                <hr className="footer-hr"/>
                <div className="copy-right">
                    © 2020 GameMeet All rights reserved
                </div>
            </div>
        )
    }
}

export default Footer
